import * as colors from '@atlaskit/theme/colors';
import { themed } from '@atlaskit/theme/components';
export var arrow = {
    defaultColor: themed({ light: colors.N40, dark: colors.DN40 }),
    selectedColor: themed({ light: colors.N300, dark: colors.DN300 }),
    hoverColor: themed({ light: colors.N60, dark: colors.DN60 }),
};
export var row = {
    focusOutline: themed({ light: colors.B100, dark: colors.B100 }),
    highlightedBackground: themed({ light: colors.N20, dark: colors.DN50 }),
    hoverBackground: themed({ light: colors.N10, dark: colors.DN40 }),
    hoverHighlightedBackground: themed({ light: colors.N30, dark: colors.DN60 }),
};
export var head = {
    borderColor: themed({ light: colors.N40, dark: colors.DN50 }),
    textColor: themed({ light: colors.N300, dark: colors.DN300 }),
};
//# sourceMappingURL=theme.js.map